<template>
  <adn-modal ref="contactMyTCModal" size="normal" :title="i18n._('Contacter mon technicien')">
    <template #body>
      <div class="idf-contact-card__container" v-for="contact in contactList" :key="contact.uuid">
        <idf-contact-card
          :first-name="contact.first_name"
          :last-name="contact.last_name"
          :description="computeDescription(contact)"
          :phone="contact.mobile_phone"
          :email="contact.email"
          data-test-contact-card
        />
      </div>
    </template>
  </adn-modal>
</template>

<script lang="ts">
import { ref, defineComponent, type PropType } from 'vue'
import { isFarmi } from '@b2ag/app-brands'
import IdfContactCard from '@b2ag/design-system/src/components/IdfContactCard/IdfContactCard.vue'
import AdnModal from '@b2ag/design-system/src/components/AdnModal/AdnModal.vue'
import { i18n } from '@b2ag/locale'
import { formattedExpertiseDomains, formattedRoleExpertiseDomains } from '../utils/technician-domains'
import type { contactList } from './typings'

export default defineComponent({
  name: 'PContactTechnicalSaleModal',
  components: { AdnModal, IdfContactCard },
  props: {
    contactList: {
      type: Array as PropType<contactList[]>,
      default: () => [],
      required: true,
    },
  },
  setup() {
    const contactMyTCModal = ref<(typeof AdnModal & { show: () => void; hide: () => void }) | null>(null)

    const show = () => {
      contactMyTCModal.value?.show()
    }
    const hide = () => {
      contactMyTCModal.value?.hide()
    }
    const computeDescription = (technicalSale) =>
      isFarmi ? formattedRoleExpertiseDomains(technicalSale) : formattedExpertiseDomains(technicalSale)

    return {
      i18n,
      contactMyTCModal,
      show,
      hide,
      computeDescription,
    }
  },
})
</script>

<style lang="scss" scoped>
.idf-contact-card__container {
  &:not(:first-child) {
    margin-top: var(--spacing-2);
  }

  &:not(:last-child) {
    margin-bottom: var(--spacing-2);
  }
}
</style>
